import { render } from "./BaseIframeView.vue?vue&type=template&id=470500d0&scoped=true"
import script from "./BaseIframeView.vue?vue&type=script&lang=js"
export * from "./BaseIframeView.vue?vue&type=script&lang=js"

import "./BaseIframeView.vue?vue&type=style&index=0&id=470500d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470500d0"]])

export default __exports__